import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { OfficeProfileRo } from '@/types';
import { GET_OFFICE_PROFILE } from '@/constants';
import { ErrorResponse } from '@/types';
import { withOfficeProfileImageCacheBust } from '@/common/helpers/officeProfileImageCache';

export const useGetOfficeProfile = (
  options?: Partial<UseQueryOptions<OfficeProfileRo, AxiosError<ErrorResponse>>>,
) =>
  useQuery<OfficeProfileRo, AxiosError<ErrorResponse>>({
    queryKey: ['office-profile'],
    queryFn: () =>
      axios
        .get<OfficeProfileRo>(GET_OFFICE_PROFILE)
        .then((res) => withOfficeProfileImageCacheBust(res.data)),
    ...options,
  });
